import { createSelector } from 'reselect';
import { StateWithSeatMap } from './types';

export const getSeatMapState = (state: StateWithSeatMap) => state.seatMap;

export const getActivePassengerFilters = createSelector(
	getSeatMapState,
	({ activePassengerFilters }) => activePassengerFilters
);
